<template>
    <section class="page-content">
        <TopBackgroundComponent/>
        <GalleryComponent/>
    </section>
</template>

<script setup>
    import TopBackgroundComponent from '../components/TopBackgroundComponent.vue';
    import GalleryComponent from '@/components/gallery/GalleryComponent.vue';
    window.scrollTo(0, 0);
</script>

<style scoped>
    /*  */
</style>